import React from 'react';
import PropTypes from 'prop-types';
import styles from './Button.module.css';

const Button = ({ as: Component = 'button', variant = 'primary', size = 'md', leadingIcon, trailingIcon, children, className = '', ...props }) => {
  const classes = [styles.button, styles[variant], styles[size], className].filter(Boolean).join(' ');

  return (
    <Component className={classes} {...props}>
      {leadingIcon && <span className={styles.icon}>{leadingIcon}</span>}
      <span className={styles.label}>{children}</span>
      {trailingIcon && <span className={styles.icon}>{trailingIcon}</span>}
    </Component>
  );
};

Button.propTypes = {
  as: PropTypes.elementType,
  variant: PropTypes.oneOf(['primary', 'secondary', 'ghost', 'quiet']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  leadingIcon: PropTypes.node,
  trailingIcon: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string
};

export default Button;
